import { useState, useEffect } from "react";
import Slider from "../../components/Home/Slider";
import { Col, Container, Row } from "react-bootstrap";
import TopContent from "../../components/Home/TopContent";
import FilterBar from "../../components/Home/FilterBar";
import AnimalList from "../../components/Home/AnimalList";
import SideBar from "../../components/Home/SideBar/SideBar";
import PopularDogBreedType from "../../components/Home/PopularDogBreedType";
import PopularBreeder from "../../components/Home/PopularBreeder";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import styles from "./home.module.css";

import Popup from "../../components/popup/Popup";

function Home() {
  const { width } = useWindowDimensions();

  const [isPopupOpen, setPopupOpen] = useState(false);
  const [hasPopupShown, setHasPopupShown] = useState(false);

  useEffect(() => {
    const popupData = JSON.parse(localStorage.getItem("popupData")) || { count: 0 };

    if (popupData.count >= 1) return; // stop showing popup if submitted or count is 1

    const handleScroll = () => {
      if (hasPopupShown) return; // stop each scrolling to showing 

      const scrollHeight = document.documentElement.scrollHeight;
      const scrollTop = document.documentElement.scrollTop;
      const clientHeight = document.documentElement.clientHeight;
      const scrolledPercentage = (scrollTop + clientHeight) / scrollHeight;

      if (scrolledPercentage > 0.6) {
        setPopupOpen(true);
        setHasPopupShown(true); // stop showing again after closing popup

        // update popup count in localStorage
        const updatedPopupData = { ...popupData, count: popupData.count + 1 };
        localStorage.setItem("popupData", JSON.stringify(updatedPopupData));
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasPopupShown]);

  // prevent scrolling when popup is open
  // useEffect(() => {
  //   if (isPopupOpen) {
  //     document.body.style.overflow = "hidden";
  //   }
  //   return () => {
  //     document.body.style.overflow = "";
  //   };
  // }, [isPopupOpen]);

  const handlePopupClose = () => {
    setPopupOpen(false);
  };

  return (
    <>
      <Container className={`${width <= 576 ? ` ${styles.mobile}` : ""}`}>
        <Row style={{ position: "relative", zIndex: -1 }} className={`${width <= 576 ? ` ${styles.mobileRow}` : ""}`}>
          <Slider />
          <TopContent />
        </Row>
      </Container>
      <FilterBar />
      <div className={styles.grayArea}>
        <Container>
          <Row>
            <Col sm={{ span: 9 }}>
              <AnimalList />
              <PopularDogBreedType />
              <PopularBreeder />
            </Col>
            <Col sm={{ span: 3 }} className={`${width <= 576 ? "px-0" : ""}`}>
              <SideBar />
            </Col>
          </Row>
        </Container>
      </div>
      <Popup isOpen={isPopupOpen} onClose={handlePopupClose} />
    </>
  );
}

export default Home;

